import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { ConfigPedidoModule } from '../../../../configuracoes/app/pedido';
import { PedidoStatusModule } from '../../../status';

import { PedidoNaoLiberadoCardInfoLimiteCreditoExcedidoComponent } from './pedido-nao-liberado-card-info-limite-credito-excedido.component';

@NgModule({
    imports: [
        SharedModule,
        ConfigPedidoModule,
        PedidoStatusModule
    ],
    declarations: [
        PedidoNaoLiberadoCardInfoLimiteCreditoExcedidoComponent
    ],
    exports: [
        PedidoNaoLiberadoCardInfoLimiteCreditoExcedidoComponent
    ]
})
export class PedidoNaoLiberadoCardInfoLimiteCreditoExcedidoModule { }
